import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import { SubscribeForm } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  media: MediaProps[];
  heading: string;
  text: string;
  iframeUrl: string;
}

interface Subscribev2Props extends PageSectionProps {
  blok: Blok;
}

const sectionClasses = (sectionClassName?: string): string => classnames('sb-newsletter', sectionClassName);

export const Subscribev2: FunctionComponent<React.PropsWithChildren<Subscribev2Props>> = ({
  blok,
  sectionClassName
}) => {
  const { hasBackground, hasBorder, media, heading, text, iframeUrl, hasPaddingTop, hasPaddingBottom } = blok;

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClasses(sectionClassName)}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <SubscribeForm
        mediaProps={{ src: media[0].img, alt: media[0].alt, loading: 'lazy' }}
        heading={heading}
        text={text}
        position="left"
      >
        <iframe title="newsletterForm" className="md:mx-auto min-h-88" src={iframeUrl} width="320" />
      </SubscribeForm>
    </Section>
  );
};
